import { BucketS3Env } from '@qaroni-core/config/bucket-s3/bucket-s3.config';
import { LinkTag } from './link-tag';

export const LINKTAGSARRAY: LinkTag[] = [
  {
    rel: 'shortcut icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon.ico`,
    type: 'image/x-icon',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-16x16.png`,
    type: 'image/png',
    sizes: '16x16',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-32x32.png`,
    type: 'image/png',
    sizes: '32x32',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-96x96.png`,
    type: 'image/png',
    sizes: '96x96',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-57x57.png`,
    sizes: '57x57',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-60x60.png`,
    sizes: '60x60',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-72x72.png`,
    sizes: '72x72',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-76x76.png`,
    sizes: '76x76',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-114x114.png`,
    sizes: '114x114',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-120x120.png`,
    sizes: '120x120',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-144x144.png`,
    sizes: '144x144',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-152x152.png`,
    sizes: '152x152',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-180x180.png`,
    sizes: '180x180',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon-precomposed.png`,
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-icon.png`,
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-36x36.png`,
    type: 'image/png',
    sizes: '36x36',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-48x48.png`,
    type: 'image/png',
    sizes: '48x48',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-72x72.png`,
    type: 'image/png',
    sizes: '72x72',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-96x96.png`,
    type: 'image/png',
    sizes: '96x96',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-144x144.png`,
    type: 'image/png',
    sizes: '144x144',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-icon-192x192.png`,
    type: 'image/png',
    sizes: '192x192',
  },
  {
    rel: 'stylesheet',
    href: `https://fonts.googleapis.com/icon?family=Material+Icons`,
  },
];
